// News.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NewsSlider from './Slider';

const News = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios.get('https://mfchub.com/wp-json/wp/v2/posts/')
      .then(response => {
        if (Array.isArray(response.data)) {
          setNews(response.data.map(item => ({
            id: item.id,
            title: item.title.rendered,
            excerpt: item.excerpt.rendered,
            image: item.featured_media ? `https://mfchub.com/wp-json/wp/v2/media/${item.featured_media}` : 'https://via.placeholder.com/150',
            url: item.link,
          })));
        } else {
          console.error('Unexpected response format:', response.data);
          setNews([]);
        }
      })
      .catch(error => {
        console.error('Error fetching news:', error);
        setNews([]);
      });
  }, []);

  return (
    <div>
      <NewsSlider newsData={news.slice(0, 5)} />
    </div>
  );
};

export default News;
